import { FormControl, Select, MenuItem } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import React, { useState, useEffect } from 'react';
import { OperatorsEnum } from '../../utils/enum/OperatorsType';
import { Operators, FilterDateInterface } from '../HotAlerts/hotAlertsInterface';
import { QUESTION_TYPE } from '../Modals/DashboardModal/constants';
import { TextFieldStyled } from './styled';

type DateFilterProps = {
    columnId: string
    selectedFilterDateValue?: FilterDateInterface
    handleSelectedFilterDateValue: (property: string, filterDateValue: FilterDateInterface, filterType: QUESTION_TYPE) => void
}

export default function DateFilter(props: DateFilterProps) {
    const { columnId, selectedFilterDateValue, handleSelectedFilterDateValue } = props;
    const [selectedOperator, setSelectedOperator] = useState<OperatorsEnum>(selectedFilterDateValue!.operator ? selectedFilterDateValue!.operator : OperatorsEnum.EQUAL);
    const [selectedDate, setSelectedDate] = useState<Date | null>(selectedFilterDateValue!.date ? selectedFilterDateValue!.date : null);
    const [actualDateFilterValue, setActualDateFilterValue] = useState<FilterDateInterface>(selectedFilterDateValue!);
    const [hasToSendDate, setHasToSendDate] = useState<boolean>(false);

    useEffect(() => {
        if (hasToSendDate) {
            handleSelectedFilterDateValue(columnId, actualDateFilterValue, QUESTION_TYPE.DATE);
            setHasToSendDate(false);
        }
    }, [hasToSendDate]);

    const handleChangeOperator = (event: SelectChangeEvent<OperatorsEnum>) => {
        const {
            target: { value },
        } = event;

        const operatorToApply = value as OperatorsEnum;
        setSelectedOperator(operatorToApply);
        const newDateFilterValue: FilterDateInterface = { date: selectedDate, operator: operatorToApply };
        setActualDateFilterValue(newDateFilterValue);
        setHasToSendDate(true);
    };

    const handleChangeDate = (event: SelectChangeEvent<string>) => {
        const {
            target: { value },
        } = event;
        if (!value || value === '') {
            setSelectedDate(null);
            setActualDateFilterValue({ date: null, operator: null });
            setHasToSendDate(true);

            return;
        }
        setSelectedDate(new Date(value));
        const newDateFilterValue: FilterDateInterface = { date: new Date(value), operator: selectedOperator };
        setActualDateFilterValue(newDateFilterValue);
        setHasToSendDate(true);
    };

    return (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', width: '100%' }}>
            <FormControl size='small' sx={{ minWidth: 50 }}>
                <Select
                    inputProps={{ 'aria-label': `${columnId}-hotalert-date-operator` }}
                    onChange={handleChangeOperator}
                    value={selectedOperator}
                    variant='standard'
                    displayEmpty
                >
                    {Operators.map((operator) => <MenuItem key={operator.id} value={operator.id}>{operator.label}</MenuItem>)};
                </Select>
            </FormControl>

            <TextFieldStyled
                InputLabelProps={{ shrink: false }}
                id={`filter-${columnId}-date`}
                onChange={handleChangeDate}
                size='small'
                sx={{ minWidth: 150 }}
                type='date'
                value={selectedDate?.toLocaleDateString('en-CA')}
                variant='standard'
            />
        </div>
    );
}
